import { AbstractControl } from '@angular/forms';

export function missingValueValidator(control: AbstractControl) {
    return !control.get('month').value || !control.get('day').value || !control.get('year').value ?
        { missingValue: true } : null;
}
